<template>
  <v-container id="create_edit_ingredient" fluid tag="section">
    <base-v-component :heading="$t('ingredient-view')" />

    <v-row 
      v-if="!isLoading"
      align="center" 
      justify="center" 
      class="mt-8"
    >
      <v-btn color="primary" class="mr-0" rounded @click="onCreateEvaluation">{{ $t('create-evaluation') }}</v-btn>
    </v-row>

    <v-row 
      v-if="!isLoading"
      align="center" 
      justify="center" 
      class="mt-8"
    >
      <v-col cols="8">
    
      <v-list
        v-if="evaluations.length>0"
        subheader
        two-line
      >
        <v-subheader>{{ $t('evaluations') }}</v-subheader>
        <v-list-item
          v-for="item in evaluations"
          :key="item.id"
          @click="onClickEvaluation(item.id)"
        >
          <v-list-item-content>
            <v-list-item-title v-text="item.inciName"></v-list-item-title>
            <v-list-item-subtitle>{{ $t('updated') }}: {{ $moment(item.updated).format('YYYY-MM-DD') }}</v-list-item-subtitle>
            <v-list-item-subtitle>Id: {{ item.id }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      </v-col>
    </v-row>

    <template>
      <v-card class="mx-auto px-8">
        <v-form>
          <v-container v-if="isLoading">
            <v-row>
              <v-col>
                <v-progress-linear
                  :active="isLoading"
                  :indeterminate="true"
                  height="4"
                />
              </v-col>
            </v-row>
          </v-container>
          <v-container v-if="!isLoading">
            <v-row>
              <v-col cols="12" md="9">
                
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="9">
                <v-text-field v-model="editingObject.inciName" label="INCI Name" outlined readonly />
              </v-col>
              <v-col cols="12" md="3" class="text-right pt-6">
                 <v-tooltip v-if="isProhibited()" bottom>
                  <template #activator="{ on }">
                    <v-icon v-on="on" class="mr-2" color="red">mdi-alert</v-icon>
                  </template>
                  <span>Ingredient is prohibited (Annex 2)</span>
                </v-tooltip>
                <v-tooltip v-if="isRestricted()" bottom>
                  <template #activator="{ on }">
                    <v-icon v-on="on" class="mr-2">mdi-alert-circle-outline</v-icon>
                  </template>
                  <span>Ingredient has restriction (Annex 3)</span>
                </v-tooltip>
                <v-btn
                  v-if="cosingLink"
                  text
                  :href="cosingLink"
                  target="_blank"
                >
                  Cosing
                  <v-icon right dark>mdi-arrow-top-right</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="editingObject.innName" label="INN Name" outlined readonly />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field 
                  v-model="editingObject.casNumber" 
                  label="CAS number" 
                  outlined readonly
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field 
                  v-model="editingObject.ecNumber" 
                  label="EC number" 
                  outlined 
                  readonly
                />
              </v-col>
              <v-col cols="12">
                <v-textarea 
                  outlined 
                  rows="10" 
                  v-model="editingObject.function" 
                  label="Function" 
                  readonly
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  outlined
                  rows="10"
                  v-model="editingObject.iupacName"
                  label="IUPAC Name"
                  readonly
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  outlined
                  rows="10"
                  v-model="editingObject.restriction"
                  label="Restriction"
                  readonly
                />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card>
    </template>
  </v-container>
</template>

<script>
export default {
  name: "ViewIngredient",

  data: () => ({
    isLoading: false,
    search: "",
    id: null,
    editingObject: {},
    restriction: {},
    prohibited: {},
  }),

  created() {
    this.id = this.$route.params.id ? this.$route.params.id : null;
    this.init();
  },

  watch: {
    activeProject: function () {
      if (this.isLoading) {
        this.init();
      }
    },
  },

  computed: {
    user() {
      return this.$store.getters["user/getUser"];
    },
    company() {
      return this.$store.getters['company/getCompany']
    },
    activeProject() {
      return this.$store.getters["projects/getActiveProject"];
    },
    cosingLink() {
      if (!this.editingObject.reference) return null;
      const url = " https://ec.europa.eu/growth/tools-databases/cosing/index.cfm?fuseaction=search.details_v2&id=";
      return url + '' + this.editingObject.reference;
    },
    evaluations() {
      return this.$store.getters["projectIngredients/getEvaluationsByIngredient"](this.editingObject)
    }
  },

  methods: {
    async init() {
      if (this.id) {
        
        this.isLoading = true;

        if(this.activeProject && this.activeProject.id) {
          await this.$store.dispatch("ingredients/fetchIngredient", { projectId: this.activeProject.id, reference: this.id });
          const item = this.$store.getters["ingredients/getIngredient"](this.id);
          if (item) {
            this.editingObject = JSON.parse(JSON.stringify(item));
            this.editingObject.projectId = this.activeProject.id;
            this.editingObject.companyId = this.company.id;
            this.editingObject.updatedBy = this.user.id;
            this.isLoading = false;

            await this.$store.dispatch("projectIngredients/fetchEvaluationsByIngredient", { projectId: this.activeProject.id, item: this.editingObject });

          } else {
            console.log('error no item found');
            this.isLoading = false;
          }
        }
      } else {
        console.log('error no id');
      }
    },
    isProhibited () {
      return this.$store.getters["ingredients/isProhibited"](this.editingObject);
    },
    isRestricted () {
      return this.$store.getters["ingredients/isRestricted"](this.editingObject);
    },
    onCreateEvaluation() {
      this.$router.push({
        name: "evaluations.create",
        params: { item: this.editingObject },
      });
    },
    onClickEvaluation(id) {
      this.$router.push({
        name: "evaluations.edit",
        params: { id },
      });
    },
  },
};
</script>
